import React from 'react'
import c from 'classnames'
import { connect } from 'react-redux'
import Button from 'discada/dist/Button'
import Icon from 'discada/dist/Icon'

import Pricing, { DealAdditions } from 'components/VRP/Pricing'
import Survey from 'components/Quote/Survey'
import EasySection from 'components/Quote/EasyPencilSection'
import { SurveyTour } from 'components/widgets/Tour'
import Reactions from 'components/Quote/Reactions'
import ProgramInfo from 'components/Quote/ProgramInfo'

import {
  isProgramExpired,
  shouldShowSummary,
  doesPrepencilExist,
  getIsLoading,
} from 'selectors/quoteSelectors'

import { getRooftopSalesPhone } from 'selectors/appStatusSelectors'
import { formatPhone } from 'utils'

import { updateQuote, trackSection, trackReaction } from 'actions/quoteActions'
import { addToPageState } from 'actions/pageStateActions'
import { getQueryValue } from 'selectors/pageStateSelectors'

import './index.scss'

export class Quote extends React.Component {
  constructor(...args) {
    super(...args)

    this.toggleTour = () => {
      try {
        localStorage.removeItem('tour-advanced-quote')

        this.setState({ showTour: true }, () =>
          setTimeout(() => this.setState({ showTour: false }), 1),
        )
      } catch (e) {
        console.warn(e)
      }
    }
  }

  state = { showTour: false }

  render() {
    let {
      vehicleId,
      quoteId,
      mode,
      addToPageState,
      trackSection,
      hideSurvey,
      isSelectedProgramExpired,
      showSummary,
      phoneNumber,
      isLoading,
    } = this.props

    return (
      <div className={c('quote-outer')}>
        <div className={c('quote-wrapper', c)}>
          <EasySection key="survey" className="survey">
            <div className="paper-wrapper">
              <div className="pricing-survey">
                <Pricing
                  key="pricing"
                  {...this.props}
                  selectSection={this.selectSection}
                />
                <Survey {...this.props} customer hideOptions={hideSurvey} />
              </div>

              <Reactions {...this.props} />

              {mode === 'cash' && (
                <ProgramInfo
                  {...this.props}
                  hideHeader
                  hideDisclaimer
                  className="cash-details"
                />
              )}

              {phoneNumber && (
                <h5 className="phone-number-cta">
                  Have questions? Give us a call!{' '}
                  <strong>
                    <a href={`tel:${phoneNumber}`}>
                      <Icon icon="phone" /> {formatPhone(phoneNumber)}
                    </a>
                  </strong>
                </h5>
              )}

              <DealAdditions {...this.props} />

              <div className="quote-controls">
                {showSummary && (
                  <Button
                    text
                    size="small"
                    className="contract-details-link"
                    onClick={() => {
                      addToPageState({ contractDetails: mode }, null, true)
                      trackSection(
                        vehicleId,
                        quoteId,
                        'customer-contract-details',
                        true,
                      )
                    }}
                  >
                    Summary
                  </Button>
                )}
                <Button size="small" text outlined onClick={this.toggleTour}>
                  How does this work?
                </Button>
                <Button
                  size="small"
                  text
                  outlined
                  onClick={() => addToPageState({ disclaimer: true })}
                >
                  Disclaimer
                </Button>
              </div>

              {isSelectedProgramExpired && (
                <div className="expiration-warning">
                  <span>
                    <Icon icon="asterisk" /> This program has expired. New
                    programs for this car are arriving soon.
                  </span>
                </div>
              )}
            </div>
          </EasySection>
        </div>
        {!isLoading && <SurveyTour reset={this.state.showTour} />}
      </div>
    )
  }
}

function mapStateToProps(state, op) {
  return {
    ...op,
    hideSurvey: getQueryValue(state, 'h') || op.mode === 'cash',
    isSelectedProgramExpired: isProgramExpired(
      state,
      op.vehicleId,
      op.quoteId,
      op.mode,
    ),
    isLoading: getIsLoading(state, op.vehicleId, op.quoteId),
    phoneNumber: getRooftopSalesPhone(state),
    showSummary: shouldShowSummary(state, op.vehicleId, op.quoteId),
    prepencilExists: doesPrepencilExist(state, op.vehicleId, op.quoteId),
  }
}

export default connect(
  mapStateToProps,
  { updateQuote, addToPageState, trackSection, trackReaction },
)(Quote)
